<template>
  <div>
    <div class="full-page">
      <div class="thanks-bg">
        <div class="container">
          <div class="col-md-12">
            <div class="thanks-section">
              <div>
                <img
                  src="../assets/images/thank-you.png"
                  class="img-fluid downlod-img"
                  alt=""
                >
                <div class="col-lg-8 offset-lg-2">
                  <h2>Reset email will be sent to you</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="bg-thanks">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="copyright-section">
                <p>2023 Copyright &copy; By ezfixd.com</p>
                <div class="mt-3 text-center">
                  <router-link :to="{ name: 'Home' }" v-slot="{ navigate }">
  <a class="btn btn-custom theme-color theme-color pt-2 pb-2" @click="navigate">
    BACK TO HOME PAGE
  </a>
</router-link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <js />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'AfterForgetPassword',
  mounted: function() {
    $('.navbar').addClass('darkHeader')
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/after_forget_password.vue